const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isGuid(value: string | null | undefined): value is string {
  return !!value && GUID_PATTERN.test(value.trim());
}

export function toGuidOrUndefined(
  value: string | null | undefined,
): string | undefined {
  return isGuid(value) ? value.trim() : undefined;
}

